import request from '@/utils/request'

export const pbsqQuestionApi = {
  list: params => request.get('/pbsq/question/list', { params }),
  create: data => request.post('/pbsq/question', data),
  update: data => request.put('/pbsq/question', data),
  remove: id => request.delete(`/pbsq/question/${id}`)
}
